import handlePromise from 'utils/handle-promise'

const BASE_URL = process.env.API_HOST || 'https://api.learning.rest'

export async function getReviewsByCourse(course_id) {
  const data = await handlePromise(`${BASE_URL}/api/reviews?course_id=${course_id}`)
  return data
}

export async function getReviewsService({ page_size, course = null, page = 1 }) {
  const pageSize = page_size || 25
  const courseParam = course ? `&course_slug=${course}` : ''
  const url = `/api/v1/reviews/?page_size=${pageSize}&page=${page}${courseParam}`
  const data = await handlePromise(url, { method: 'GET' })
  return data
}

export async function postReview({
  course_slug, comment, token, stars,
}) {
  const url = `/api/v1/courses/${course_slug}/review/`
  const formData = new FormData()
  formData.append('stars', stars)
  formData.append('comment', comment)
  const data = await handlePromise(url, {
    method: 'POST',
    headers: { Authorization: token },
    body: formData,
  })
  return data
}

export async function createReview({
  course, comment, token, stars,
}) {
  const url = `/api/v1/courses/${course}/review/`
  const formData = new FormData()
  formData.append('stars', stars)
  formData.append('comment', comment)
  const data = await handlePromise(url, {
    method: 'POST',
    headers: { Authorization: token },
    body: formData,
  })
  return data
}
